"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketVersioningInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketVersioningInput.js.map